class VwSonucIzlemeTanimDTO {

    id: number = null;
    testGrupId: number = null;
    durumId: number = null;
    bgRenk: string = null;
    txRenk: string = null;
    fkOrganizasyon: number = null;
    aktif: string = null;
    eklemeTarihi?: string = null;
    ekleyenKullanici?: number = null;
    guncellemeTarihi?: string = null;
    guncelleyenKullanici?: number = null;
    organizasyonAdi: string = "";
    testGrupAdi: string = "";
}

export default VwSonucIzlemeTanimDTO